export class SearchFilter {
  constructor() {
    // Bind event handlers
    this.handleUpdate = this.handleUpdate.bind(this);

    // Initialize component
    this.init();
  }

  init() {
    this.form = document.querySelector('[data-ui="search-filter"]');

    if (this.form) {
      this.form.addEventListener('dropdown-update', this.handleUpdate);
      this.searchParams = new URLSearchParams(window.location.search);
      this.filtered = this.searchParams.get('orderby');
      this.highlightFilter();
    }
  }

  handleUpdate(event) {
    event.preventDefault();

    const values = {
      categories: this.form.elements['filter-tags']
        ? this.form.elements['filter-tags'].value
        : '',
      keyword: this.form.elements['filter-keyword']
        ? this.form.elements['filter-keyword'].value
        : '',
      orderby: this.form.elements['filter-orderby']
        ? this.form.elements['filter-orderby'].value
        : ''
    };

    const queryString = this.updateQueryString(
      window.location.href,
      'orderby',
      values.orderby
    );

    const queryStringWithTags = this.updateQueryString(
      queryString,
      'cat',
      values.categories
    );

    // Update query string
    window.location.href = queryStringWithTags;
  }

  updateQueryString(uri, key, value) {
    const re = new RegExp('([?&])' + key + '=.*?(&|#|$)', 'i');

    // Adds, updates, or replaces key=value pairs
    if (value === undefined) {
      if (uri.match(re)) {
        return uri.replace(re, '');
      } else {
        return uri;
      }
    } else if (uri.match(re)) {
      return uri.replace(re, '$1' + key + '=' + value + '$2');
    } else {
      let hash = '';

      if (uri.indexOf('#') !== -1) {
        hash = uri.replace(/.*#/, '#');
        uri = uri.replace(/#.*/, '');
      }
      const separator = uri.indexOf('?') !== -1 ? '&' : '?';

      return uri + separator + key + '=' + value + hash;
    }
  }

  highlightFilter() {
    const highlightedClass = 'bio-dropdown-filter-form--filtered';

    if (this.filtered) {
      this.form.classList.add(highlightedClass);
    } else {
      this.form.classList.remove(highlightedClass);
    }
  }
}

export default SearchFilter;
